
import httpManager from "../../util/common";
import { initReportOptions, reportTrans } from "../js/report_trans"
import XEUtils from 'xe-utils'

import FundSearch from "../components/FundSearch"
const max_pageSize = 200
const filter_options = [
    { label: "10个最大值", value: '10' },
    { label: "10个最小值", value: '-10' },
    { label: "高于平均值", value: '1' },
    { label: "低于平均值", value: '-1' },
    { label: "等于空值", value: '0' },
]
export default {
    components: { FundSearch },
    data() {
        return {
            product_id: "",
            product_manager: "",
            product_type: "",
            report_period: "",
            investment_type: "",
            esg_strategy_type: "",
            report_options: [
            ],
            product_type_options: [
                {label: '银行理财', value: '银行理财'},
                {label: '公募基金', value: '公募基金'},
            ],
            investment_options: [
                { label: '混合类', value: '混合类' },
                { label: '权益类', value: '权益类' },
                { label: '固定收益类', value: '固定收益类' }
            ],
            esg_strategy_options: [
                {label: "ESG主题基金", value: "ESG主题基金"},
                {label: "ESG策略基金", value: "ESG策略基金"},
                {label: "低碳及绿色发展基金", value: "低碳及绿色发展基金"},
                {label: "社会责任基金", value: "社会责任基金"},
                {label: '公司治理基金', value: '公司治理基金' },
                {label: '非ESG基金', value: '非ESG基金' },
            ],
            /*
                所有列默认进行排序
                配置项中isFormatter比较特殊
                false表示不格式化
                true表示保留两位小数
                自定义字符串表示保留两位小数后再添加该字符串
                ！！！
                若不想使用该配置项中格式化方式
                可将isFormatter置为false或不添加isFormatter
                然后使用customFormatter自定义
                *** 若isFormatter为true且customFormatter存在默认使用customFormatter ***
            */
            table_columns_config: [
                { field: 'ticker', title: '基金代码' },
                { field: 'short_name', title: '基金简称' },
                { field: 'full_name', title: '基金全称' },
                { field: 'product_manager', title: '基金管理人' },
                { field: 'product_type', title: '产品类型' },
                { field: 'investment_type', title: '投资性质' },
                { field: 'esg_strategy_type', title: 'ESG基金类型' },
                { field: 'report_period', title: '报告期' },
                { field: 'asset_type', title: '资产类别' },
                { field: 'high_environmental_risk_ratio', title: '双高项目占比', isFilter: true, isFormatter: '%' },
                { field: 'newenergy_patent_quality', title: '新能源技术专利质量', isFilter: true, isFormatter: true },
                { field: 'newenergyvehicle_patent_quality', title: '新能源汽车技术专利质量', isFilter: true, isFormatter: true },
                { field: 'greenbuilding_patent_quality', title: '绿色建筑技术专利质量', isFilter: true, isFormatter: true },
                { field: 'ccus_patent_quality', title: 'CCUS技术专利质量', isFilter: true, isFormatter: true },
                { field: 'wastemanagement_patent_quality', title: '废物管理技术专利质量', isFilter: true, isFormatter: true },
                { field: 'energysaving_patent_quality', title: '节能技术专利质量', isFilter: true, isFormatter: true },
                { field: 'yield_7d', title: '7天收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_30d', title: '30天收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_90d', title: '90天收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_180d', title: '180天收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_52w', title: '52周收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_3y', title: '3年收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_5y', title: '5年收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_accumulated', title: '累计收益率', isFilter: true, isFormatter: '%' },
                { field: 'yield_annual', title: '平均年化收益率', isFilter: true, isFormatter: '%' },
            ],
            tableColumns: [],
            page: {
                total: 0,
                currentPage: 1,
                pageSize: 10,
                align: 'center',
                pagerCount:3,
                layouts: ['PrevPage', 'Number', 'NextPage'],
                perfect: true
            },
            loading: false,
            exportConfig: {},
            original_data: [], //源数据，先筛选后分页
            formDatas: [], // 筛选后的数据
            formData: [],   // 分页后数据
            avgs: {
                high_environmental_risk_ratio: 0,
                newenergy_patent_quality: 0,
                newenergyvehicle_patent_quality: 0,
                greenbuilding_patent_quality: 0,
                ccus_patent_quality: 0,
                wastemanagement_patent_quality: 0,
                energysaving_patent_quality: 0,
                yield_7d: 0,
                yield_30d: 0,
                yield_90d: 0,
                yield_180d: 0,
                yield_52w: 0,
                yield_accumulated: 0,
                yield_annual: 0
            },
            sort_column:'report_period',
            sort_order:'desc',
        }
    },
    methods: {
        // 排序按钮事件
        sortChangeEvent({ column, property, order }){
            this.sort_column=property
            this.sort_order=order
            if(!this.sort_order){
                this.sort_order='desc'
                this.sort_column='report_period'
            }
            this.getFundIndicatorData()
        },

        sortByNumber({ data, sortList }) {
            const sortItem = sortList[0]
            const { property, order } = sortItem
            let list = []
            let list_number = []
            let list_null = []
            data.forEach(element => {
                if (!element[property] && element[property] !== 0)
                    list_null.push(element)
                else list_number.push(element)
            })

            if (order === 'asc')
                list_number.sort((a, b) => a[property] - b[property])
            else list_number.sort((a, b) => b[property] - a[property])
            list = list_number.concat(list_null)
            return list
        },
        setTableColumn() {
            this.table_columns_config.forEach(element => {
                let temp_obj = {}
                temp_obj['field'] = element.field
                temp_obj['title'] = element.title
                temp_obj['sortable'] = true
                temp_obj['sortType'] = 'number'
                if (element.isFilter) {
                    temp_obj['filters'] = filter_options
                    temp_obj['filterMethod'] = this.filterNumberMethod
                    temp_obj['filterMultiple'] = false
                }
                if (element.isFormatter) {
                    let symble = element.isFormatter === true ? '' : element.isFormatter
                    temp_obj['formatter'] = ({ cellValue }) => {
                        return (cellValue || cellValue == 0) ? (cellValue).toFixed(2) + symble : ""
                    }
                }
                this.tableColumns.push(temp_obj)
            })

        },
        aFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        reportFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        investmentFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        esgStrategyFilter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
        },
        productTypeOnChange(value, selectedOptions) {
            this.product_type = ""
            value.forEach(element => {
                this.product_type += element
            })
        },
        reportOnChange(value, selectedOptions) {
            this.report_period = ""
            value.forEach(element => {
                this.report_period += element
            })
            if (!value[1] && value[0]) {
                this.report_period += 'Q14'
            }
        },
        investmentOnChange(value, selectedOptions) {
            this.investment_type = ""
            value.forEach(element => {
                this.investment_type += element
            })
        },
        esgStrategyOnChange(value, selectedOptions) {
            this.esg_strategy_type = ""
            value.forEach(element => {
                this.esg_strategy_type += element
            })
        },
        setPage() {
            // 进行分页的操作
            this.page.total = this.formDatas.length
            this.formData = this.formDatas.slice((this.page.currentPage - 1) * this.page.pageSize, this.page.currentPage * this.page.pageSize)
        },
        pageChange({ currentPage, pageSize }) {
            // 页数切换
            this.page.currentPage = currentPage
            this.page.pageSize = pageSize
            this.setPage()
        },
        getFundIndicatorData() {
            let self = this
            let params = new Map()
            // params.set("pagenum", 10000)
            params.set("pagesize", max_pageSize)
            if (self.product_id) {
                params.set("product_id", self.product_id)
            }
            if (self.product_manager) {
                params.set("product_manager", self.product_manager)
            }
            if (self.product_type) {
                params.set("product_type", self.product_type)
            }
            if (self.report_period) {
                params.set("report_period", self.report_period)
            }
            if (self.investment_type) {
                params.set("investment_type", self.investment_type)
            }
            if (self.esg_strategy_type) {
                params.set("esg_strategy_type", self.esg_strategy_type)
            }
            if (self.asset_type) {
                params.set("asset_type", self.asset_type)
            }
            if (self.sort_column){
                params.set("sort_column", self.sort_column)
            }
            if (self.sort_order){
                params.set("sort_order", self.sort_order)
            }
            self.loading = true
            console.log('@@@',params);
            return httpManager("fund_indicators", params)
                .then(response => {
                    self.original_data = response.data.data
                    self.formDatas = response.data.data
                    self.setPage()
                    self.setAvgs(self.formDatas)
                    reportTrans(self.formDatas)
                    let page = response.data.page
                    self.page.total = page.total >= self.original_data.length ? self.original_data.length : page.total
                    self.loading = false
                }).catch(error => {
                    self.original_data = []
                    self.formDatas = []
                    self.setPage()
                    console.log(error)
                    self.loading = false
                })
        },
        setAvgs(array) {
            array.forEach(element => {
                for (let attr in this.avgs) {
                    this.avgs[attr] += element[attr] ? element[attr] : 0
                }
            })
            let size = this.formDatas.length
            for (let i in this.avgs) {
                this.avgs[i] /= size
            }
        },
        openDataExport() {
            let s = "Fund-ESG-indicators-" + this.report_period + "-"
            this.$refs.xTree.openExport({
                filename: s + XEUtils.toDateString(new Date().getTime(), 'yyyyMMddHHmmss'),
                original: true,
                types: ['csv']
            })
        },
        filterVisibleEvent({ column, visible }) {

        },
        filterChangeEvent(obj) {
            let table = this.$refs.xTree
            table.clearSort()
            let field_list = this.tableColumns.map(element => {
                return element.field
            })
            let field = obj.field
            field_list.forEach(element => {
                if (element !== field)
                    table.clearFilter(element)
            })
            let value = obj.values[0]
            let property = obj.property
            let new_data = []
            let temp_array = Object.create(this.original_data)
            switch (value) {
                case "1":
                    this.original_data.forEach(element => {
                        if (element[property] >= this.avgs[property])
                            new_data.push(element)
                    })
                    break
                case "-1":
                    this.original_data.forEach(element => {
                        if (element[property] < this.avgs[property])
                            new_data.push(element)
                    })
                case "10":
                    temp_array.sort((a, b) => b[property] - a[property])
                    for (let i = 0; i < 10; i++)
                        new_data.push(temp_array[i])
                    break
                case "-10":
                    temp_array.sort((a, b) => a[property] - b[property])
                    for (let i = 0; i < 10; i++)
                        new_data.push(temp_array[i])
                    break
                case "0":
                    this.original_data.forEach(element => {
                        if (!element[property])
                            new_data.push(element)
                    })
                    break

                default:
                    break
            }
            if (!table.isFilter()) {
                new_data = this.original_data
            }
            this.formDatas = new_data
            this.pageChange({ currentPage: 1, pageSize: this.page.pageSize })
        },
        // 筛选数据
        filterNumberMethod({ value, row, column }) {
            return 1
        },
        // // 在报告期为空时进行的数据查询
        // async emptyReportGetData() {
        //     let self = this
        //     let year = this.report_options[0]
        //     let seasons = year.children
        //     for(let i in seasons) {
        //         let report_period = year.value + seasons[i].value
        //         let params = new Map()
        //         params.set("pagesize", max_pageSize)
        //         params.set("report_period", report_period)
        //         if (self.product_id) {
        //             params.set("product_id", self.product_id)
        //         }
        //         if (self.product_manager) {
        //             params.set("product_manager", self.product_manager)
        //         }
        //         if (self.product_type) {
        //             params.set("product_type", self.product_type)
        //         }
        //         if (self.investment_type) {
        //             params.set("investment_type", self.investment_type)
        //         }
        //         if (self.esg_strategy_type) {
        //             params.set("esg_strategy_type", self.esg_strategy_type)
        //         }
        //         if (self.asset_type) {
        //             params.set("asset_type", self.asset_type)
        //         }
        //         if(self.sort_column) {
        //             params.set("sort_column", self.sort_column)
        //         }
        //         if (self.sort_order) {
        //             params.set("sort_order", self.sort_order)
        //         }
        //         self.loading = true
        //         await httpManager("fund_indicators", params).then(response => {
        //             self.original_data = response.data.data
        //             self.formDatas = response.data.data
        //             self.setPage()
        //             self.setAvgs(self.formDatas)
        //             reportTrans(self.formDatas)
        //             let page = response.data.page
        //             self.page.total = page.total > self.original_data.length ? self.original_data.length : page.total
        //             self.loading = false
        //         }).catch(error => {
        //             self.original_data = []
        //             self.formDatas = []
        //             self.setPage()
        //             console.log(error)
        //             self.loading = false
        //         })
        //         if(self.original_data&&self.original_data.length>0) {
        //             break
        //         }
        //     }
        // }
    },
    created() {
        this.setTableColumn()
        initReportOptions(this.report_options)
        // this.emptyReportGetData()
      this.getFundIndicatorData()
    },
    mounted() {
    },
    watch: {
        product_id() {
            this.getFundIndicatorData()
        },
        product_manager() {
            this.getFundIndicatorData()
        },
        product_type() {
            this.getFundIndicatorData()
        },
        report_period() {
            // if(this.report_period == '' || !this.report_period)
            //     this.emptyReportGetData()
            this.getFundIndicatorData()
        },
        investment_type() {
            this.getFundIndicatorData()
        },
        esg_strategy_type() {
            this.getFundIndicatorData()
        }
    }
}



// WEBPACK FOOTER //
// ./src/fund_esg/js/fund_esg_indicators.js